import { useLocation, useHistory } from "react-router-dom";
import "./material.css";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateMaterial } from "../../redux/apiCalls";
import Select from "react-select";
import { publicRequest } from "../../requestMethods";

export default function Material() {
    const location = useLocation();
    const history = useHistory();
    const materialId = location.pathname.split("/")[2];
    const [inputs, setInputs] = useState({});
    const dispatch = useDispatch();
    const [categories, setCategories] = useState([]);
    const [principles, setPrinciples] = useState([]);

    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );

    const material = useSelector((state) =>
        state.material.materials.find((material) => material._id === materialId)
    );

    // Redirect if not superadmin
    useEffect(() => {
        if (superadmin === false) {
            history.push("/");
        }
    }, [superadmin, history]);

    const getAllCategories = async () => {
        const res = await publicRequest.get("/category/all", {
            params: { isAdmin: true },
        });
        setCategories(res.data);
    };

    const getAllPrinciples = async () => {
        try {
            const params = {
                type: ["outright"],
            };

            const res = await publicRequest.get("/users/admin", {
                params,
            });
            setPrinciples(res.data);
        } catch (err) {
            console.error("Error fetching principles:", err);
        }
    };

    useEffect(() => {
        if (categories.length === 0) {
            getAllCategories();
        }
        if (principles.length === 0) {
            getAllPrinciples();
        }
    }, [categories, principles]);
    

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleCategoryChange = (e) => {
        setInputs((prev) => {
            return { ...prev, category: e.value };
        });
    };

    const handlePrincipleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, principle: e ? e.value : null };
        });
    };

    // Resolve category for Select: use inputs if user changed it, else material's category (may be object or id string)
    const categoryId = inputs.category !== undefined
        ? inputs.category
        : (material?.category?._id ?? (typeof material?.category === "string" ? material.category : undefined));
    const categorySelectValue = categoryId != null
        ? (() => {
            const c = categories.find((cat) => cat._id === categoryId);
            return c ? { label: c.title, value: c._id } : { label: material?.category?.title, value: categoryId };
        })()
        : null;

    // Resolve principle for Select: use inputs if user changed it, else material's principle
    const principleId = inputs.principle !== undefined ? inputs.principle : material?.principle?._id;
    const principleSelectValue = principleId != null
        ? (() => {
            const p = principles.find((pr) => pr._id === principleId);
            return p ? { label: p.name || p.email, value: p._id } : { label: material?.principle?.name || material?.principle?.email, value: principleId };
        })()
        : null;

    const handleClick = async () => {
        const updatedMaterial = {
            ...material,
            title: inputs.title !== undefined ? inputs.title : material.title,
            category: inputs.category !== undefined ? inputs.category : material.category,
            itemCode: inputs.itemCode !== undefined ? inputs.itemCode : material.itemCode,
            principle: inputs.principle !== undefined ? inputs.principle : material.principle,
        };
        await updateMaterial(material._id, updatedMaterial, dispatch);
    };

    if (!superadmin) {
        return null;
    }

    return (
        <div className="material">
            <h1 className="addProductTitle">Update Material</h1>
            <div className="addProductForm">
                <div className="addProductItem">
                    <label>Material Title</label>
                    <input
                        name="title"
                        type="text"
                        placeholder={material?.title}
                        defaultValue={material?.title}
                        onChange={handleChange}
                    />
                </div>
                <div className="addProductItem">
                    <label>Category</label>
                    <Select
                        options={categories.map((category) => ({
                            label: category.title,
                            value: category._id,
                        }))}
                        value={categorySelectValue}
                        onChange={handleCategoryChange}
                        placeholder="Select Category"
                    />
                </div>
                <div className="addProductItem">
                    <label>Item Code</label>
                    <input
                        name="itemCode"
                        type="text"
                        placeholder={material?.itemCode || "Item Code"}
                        defaultValue={material?.itemCode}
                        onChange={handleChange}
                    />
                </div>
                <div className="addProductItem">
                    <label>Principle</label>
                    <Select
                        options={principles.map((user) => ({
                            label: user.name || user.email,
                            value: user._id,
                        }))}
                        value={principleSelectValue}
                        onChange={handlePrincipleChange}
                        placeholder="Select Principle (Optional)"
                        isClearable
                    />
                </div>
                <div
                    onClick={() => handleClick()}
                    className="updateProductButton"
                >
                    Update Material
                </div>
            </div>
        </div>
    );
}
